import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_5 = { class: "flex flex-col" }

import { ref, onMounted } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { IonToolbar, IonHeader, IonButtons, IonBackButton, IonButton, IonSearchbar, loadingController, IonRadio, IonRadioGroup } from "@ionic/vue"
  import CardTemplate from "@/components/template/CardTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyFilter',
  setup(__props) {

  const companyStore = useCompanyStore()
  const keyword = ref("")
  const selected = ref("")

  const onSearch = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await companyStore.retrieveAllCompanies(
      {
        keyword: keyword.value,
        columns: "name,slug,logo",
        page: 1,
        limit: 5,
      },
      "search"
    )
    loading.dismiss()
    if (!selected.value) companyStore.filters.companies = {}
  }

  const onSelect = () => {
    if (selected.value) companyStore.filters.companies = selected.value
    else companyStore.filters.companies = {}
  }

  const onClear = () => {
    selected.value = ""
    keyword.value = ""
    companyStore.filters.companies = {}
  }

  onMounted(() => {
    onSearch()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CardTemplate, { class: "flex flex-col w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSearchbar), {
                    modelValue: keyword.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                    animated: true,
                    placeholder: "Search for company",
                    debounce: 1000,
                    class: "w-full p-0 custom",
                    color: "light",
                    onIonChange: onSearch
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(IonRadioGroup), {
                    modelValue: selected.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selected).value = $event)),
                    "allow-empty-selection": true,
                    onIonChange: onSelect
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyStore).searchResult, (result) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: `${result}_id`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_avatar, {
                              slot: "start",
                              style: {
                  '--border-radius': '10px',
                }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  alt: result.name,
                                  src: result.logo,
                                  class: "object-cover h-full w-full"
                                }, null, 8, _hoisted_2)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_3, _toDisplayString(result.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonRadio), {
                              slot: "end",
                              name: "companies",
                              value: result
                            }, null, 8, ["value"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "white",
              class: "text-primary-violet font-bold rounded-base shadow-base",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onClear()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Clear")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})